export const categories = [
  {
    categoryId: "BI-2",
    name: "Asian",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "asiatische-kueche",
    fullSlug: "~/rezept-kategorien/asiatische-kueche/BI-2",
    totalCount: "0",
    metaDescription: "Asiatische Küche & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/26e94159-5ef9-4a8c-8ade-e1c47531552d/2601_33071.jpg",
  },
  {
    categoryId: "BI-3",
    name: "Italian",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "italienische-kueche",
    fullSlug: "~/rezept-kategorien/italienische-kueche/BI-3",
    totalCount: "0",
    metaDescription: "Italienische Küche & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/0841c686-e503-4193-a2a3-4e9ecda2b5b6/2601_33039.jpg",
  },
  {
    categoryId: "BI-4",
    name: "Salads",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "salate",
    fullSlug: "~/rezept-kategorien/salate/BI-4",
    totalCount: "0",
    metaDescription: "Salate & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/b510faf6-053a-4bee-a905-a15f5dbe4394/2601_33053.jpg",
  },
  {
    categoryId: "BI-5",
    name: "Meat",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "fleisch",
    fullSlug: "~/rezept-kategorien/fleisch/BI-5",
    totalCount: "0",
    metaDescription: "Fleischgerichte & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/7606e719-a5c2-416c-9cd4-a3b0bd9db863/2601_33045.jpg",
  },
  {
    categoryId: "BI-8",
    name: "Main Course",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "hauptspeise",
    fullSlug: "~/rezept-kategorien/hauptspeise/BI-8",
    totalCount: "0",
    metaDescription: "Hauptspeisen & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/7606e719-a5c2-416c-9cd4-a3b0bd9db863/2601_33045.jpg",
  },
  {
    categoryId: "BI-9",
    name: "Appetizer",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "vorspeise",
    fullSlug: "~/rezept-kategorien/vorspeise/BI-9",
    totalCount: "0",
    metaDescription: "Vorspeisen & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/7891a37c-e707-46a2-904b-3250d2be2190/2601_33062.jpg",
  },
  {
    categoryId: "BI-10",
    name: "Dessert",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "nachspeise",
    fullSlug: "~/rezept-kategorien/nachspeise/BI-10",
    totalCount: "0",
    metaDescription: "Nachspeisen & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/2c494ccd-9264-4fa2-8395-c217dc6c2526/2601_33084.jpg",
  },
  {
    categoryId: "BI-11",
    name: "Soup",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "suppen",
    fullSlug: "~/rezept-kategorien/suppen/BI-11",
    totalCount: "0",
    metaDescription: "Suppen & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/eb7dbaec-e111-4cf6-aa00-cfd0fa1526af/2601_33064.jpg",
  },
  {
    categoryId: "BI-12",
    name: "Pasta",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "nudeln-pasta",
    fullSlug: "~/rezept-kategorien/nudeln-pasta/BI-12",
    totalCount: "0",
    metaDescription: "Nudeln & Pasta & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/8d916f4a-e085-464d-af74-73c027196e25/2601_33075.jpg",
  },
  {
    categoryId: "BI-13",
    name: "Grill",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "grillen",
    fullSlug: "~/rezept-kategorien/grillen/BI-13",
    totalCount: "0",
    metaDescription: "Grillen & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/04c84d55-74ad-415c-9465-1749a102fd0d/20250625_30.jpg",
  },
  {
    categoryId: "BI-14",
    name: "Kids",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "kindergerichte",
    fullSlug: "~/rezept-kategorien/kindergerichte/BI-14",
    totalCount: "0",
    metaDescription: "Rezepte für Kinder & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/9dd1aa0a-b07f-47dc-9816-58df74140c3b/202512_33026.jpg",
  },
  {
    categoryId: "BI-15",
    name: "Snacks",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "snacks-kleine-gerichte",
    fullSlug: "~/rezept-kategorien/snacks-kleine-gerichte/BI-15",
    totalCount: "0",
    metaDescription: "Snacks und kleine Gerichte & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/56824581-6db5-4d17-894e-192cd64d0dc2/2601_33070.jpg",
  },
  {
    categoryId: "BI-16",
    name: "Fish",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "fisch-meeresfruechte",
    fullSlug: "~/rezept-kategorien/fisch-meeresfruechte/BI-16",
    totalCount: "0",
    metaDescription: "Fischgerichte & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/b510faf6-053a-4bee-a905-a15f5dbe4394/2601_33053.jpg",
  },
  {
    categoryId: "BI-17",
    name: "Breakfast",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "fruehstueck",
    fullSlug: "~/rezept-kategorien/fruehstueck/BI-17",
    totalCount: "0",
    metaDescription: "Frühstück & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/9954d937-0cb1-490b-9863-2745293f2684/2601_33063.jpg",
  },
  {
    categoryId: "BI-18",
    name: "Bakery",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "baeckerei-kekse",
    fullSlug: "~/rezept-kategorien/baeckerei-kekse/BI-18",
    totalCount: "0",
    metaDescription: "Backwaren & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/15214827-8064-422b-83ae-2982ad39dcfe/2601_33088.jpg",
  },
  {
    categoryId: "BI-19",
    name: "Cakes",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "kuchen-torten",
    fullSlug: "~/rezept-kategorien/kuchen-torten/BI-19",
    totalCount: "0",
    metaDescription: "Kuchen & Torten & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/2c494ccd-9264-4fa2-8395-c217dc6c2526/2601_33084.jpg",
  },
  {
    categoryId: "BI-20",
    name: "Drinks",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "getraenke",
    fullSlug: "~/rezept-kategorien/getraenke/BI-20",
    totalCount: "0",
    metaDescription: "Getränke & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/32a4d082-92dc-4ad1-bf6d-aa0fc3345646/2512_32998.jpg",
  },
  {
    categoryId: "BI-21",
    name: "Casserole",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "auflauf",
    fullSlug: "~/rezept-kategorien/auflauf/BI-21",
    totalCount: "0",
    metaDescription: "Aufläufe & Rezepte für jeden Tag.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/9a64df90-b32c-4bd3-aae1-a96f7d2d44e8/20250219_55_l.jpg",
  },
  {
    categoryId: "BI-22",
    name: "Austrian Cuisine",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "oesterreichische-kueche",
    fullSlug: "~/rezept-kategorien/oesterreichische-kueche/BI-22",
    totalCount: "0",
    metaDescription: "Österreichische Küche & Rezepte.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/830f37bf-87ec-470c-816c-35850905e0ed/2601_33034.jpg",
  },
  {
    categoryId: "BI-23",
    name: "International Cuisine",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "internationale-kueche",
    fullSlug: "~/rezept-kategorien/internationale-kueche/BI-23",
    totalCount: "0",
    metaDescription: "Internationale Küche & Rezepte.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/7606e719-a5c2-416c-9cd4-a3b0bd9db863/2601_33045.jpg",
  },
  {
    categoryId: "BI-24",
    name: "Air Fryer",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "heissluftfritteuse",
    fullSlug: "~/rezept-kategorien/heissluftfritteuse/BI-24",
    totalCount: "0",
    metaDescription: "Heißluftfritteuse Rezepte.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/197585d7-a7da-443f-a1e7-a01599d0722f/2601_33083.jpg",
  },
  {
    categoryId: "BI-25",
    name: "Easter",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "ostern",
    fullSlug: "~/rezept-kategorien/ostern/BI-25",
    totalCount: "0",
    metaDescription: "Ostern Rezepte.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/e5432372-5ce0-4597-9330-689eee6ff687/20250219_27_l.jpg",
  },
  {
    categoryId: "BI-26",
    name: "Mothers Day",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "muttertag",
    fullSlug: "~/rezept-kategorien/muttertag/BI-26",
    totalCount: "0",
    metaDescription: "Muttertag Rezepte.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/3d4b2364-5edf-4911-ac9c-99ece203797e/202407_05_l.jpg",
  },
  {
    categoryId: "BI-27",
    name: "Ice Cream",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "eis",
    fullSlug: "~/rezept-kategorien/eis/BI-27",
    totalCount: "0",
    metaDescription: "Eis Rezepte.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/8272e4b5-2592-46be-98bd-071adefb1cd8/2601_33087.jpg",
  },
  {
    categoryId: "BI-28",
    name: "Christmas",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "weihnachten",
    fullSlug: "~/rezept-kategorien/weihnachten/BI-28",
    totalCount: "0",
    metaDescription: "Weihnachten Rezepte.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/9dd1aa0a-b07f-47dc-9816-58df74140c3b/202512_33026.jpg",
  },
  {
    categoryId: "BI-29",
    name: "Halloween",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "halloween",
    fullSlug: "~/rezept-kategorien/halloween/BI-29",
    totalCount: "0",
    metaDescription: "Halloween Rezepte.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/e98467aa-9c9d-49df-84e3-b1143b11565a/202509_32837.jpg",
  },
  {
    categoryId: "BI-30",
    name: "Rice",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "reis",
    fullSlug: "~/rezept-kategorien/reis/BI-30",
    totalCount: "0",
    metaDescription: "Reis Gerichte.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/cab95561-93f1-476d-90ce-a4176686c3d0/2601_33073.jpg",
  },
  {
    categoryId: "BI-31",
    name: "Side Dishes",
    count: "0",
    subCategories: [],
    isActive: true,
    slug: "beilagen",
    fullSlug: "~/rezept-kategorien/beilagen/BI-31",
    totalCount: "0",
    metaDescription: "Beilagen Rezepte.",
    image: "https://assets-eu-01.kc-usercontent.com:443/0268bcf9-b34b-019e-604f-170fbe1551e7/f6ff7eb6-00e3-4e2f-b83c-100c83577af0/2601_33069.jpg",
  },
];
